import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminInbox({ kind }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/admin/${kind}`).then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, [kind]);

  if (loading) return <p className="font-serif text-zinc-500">Carregando…</p>;

  if (items.length === 0)
    return <p className="text-sm text-zinc-500" data-testid={`admin-${kind}-empty`}>Nada por aqui ainda.</p>;

  return (
    <div className="flex flex-col gap-px bg-gold/10" data-testid={`admin-${kind}-list`}>
      {items.map((item) => (
        <div key={item.id} className="bg-[#0a0a0a] px-6 py-5">
          {kind === "leads" ? (
            <div className="flex items-center justify-between">
              <p className="text-sm text-zinc-100" data-testid="lead-email">{item.email}</p>
              <p className="text-xs text-zinc-500">{item.created_at ? new Date(item.created_at).toLocaleDateString("pt-BR") : ""}</p>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-zinc-100" data-testid="message-sender">{item.name} <span className="font-normal text-gold/70">· {item.email}</span></p>
                <p className="text-xs text-zinc-500">{item.created_at ? new Date(item.created_at).toLocaleDateString("pt-BR") : ""}</p>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{item.message}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
